import type {
  AdminSurvey,
  AdminSurveyDetailResponse,
  AdminSurveyListItem,
  AdminSurveyListResponse,
  AdminSurveyResponse,
  AdminSurveyResponseResponse,
  SurveyResponseInput,
  SurveyResponseList,
  SurveyResponseListQuery,
  SurveySummary,
  SurveySummaryResponse,
  SurveyVersion,
  SurveyVersionResponse,
} from '@mds/shared/types/survey';

import { api } from '@/lib/api';

const survey = (key: string) => `admin/surveys/${encodeURIComponent(key)}`;

export const listSurveys = (): Promise<AdminSurveyListItem[]> =>
  api.get<AdminSurveyListResponse>('admin/surveys').then((response) => response.data);

export const getSurvey = (key: string): Promise<AdminSurvey> =>
  api.get<AdminSurveyDetailResponse>(survey(key)).then((response) => response.data);

export const getSurveyVersion = (key: string, version: number): Promise<SurveyVersion> =>
  api
    .get<SurveyVersionResponse>(`${survey(key)}/versions/${version}`)
    .then((response) => response.data);

export const getSurveySummary = (key: string): Promise<SurveySummary> =>
  api.get<SurveySummaryResponse>(`${survey(key)}/summary`).then((response) => response.data);

export const listSurveyResponses = (
  key: string,
  query: SurveyResponseListQuery = {},
): Promise<SurveyResponseList> =>
  api.get<SurveyResponseList>(`${survey(key)}/responses`, { query: { ...query } });

export const getSurveyResponse = (key: string, id: string): Promise<AdminSurveyResponse> =>
  api
    .get<AdminSurveyResponseResponse>(`${survey(key)}/responses/${id}`)
    .then((response) => response.data);

export const createSurveyResponse = (
  key: string,
  input: SurveyResponseInput,
): Promise<AdminSurveyResponse> =>
  api
    .post<AdminSurveyResponseResponse>(`${survey(key)}/responses`, input)
    .then((response) => response.data);

/** `answers`, when sent, replaces every answer, and the response moves to the latest version. */
export const updateSurveyResponse = (
  key: string,
  id: string,
  input: Partial<SurveyResponseInput>,
): Promise<AdminSurveyResponse> =>
  api
    .patch<AdminSurveyResponseResponse>(`${survey(key)}/responses/${id}`, input)
    .then((response) => response.data);

export const deleteSurveyResponse = (key: string, id: string): Promise<void> =>
  api.delete<null>(`${survey(key)}/responses/${id}`).then(() => undefined);
